// extracted by mini-css-extract-plugin
module.exports = {"main-container":"Home_main-container__1DPxR"};